// This file is auto-generated by ./bin/rails application:stimulus:manifest:update'
// Run that command whenever you add a new stimulus controller

import { application } from "./application"

// app/assets/src/application/js/stimulus/ai_summary_controller.js
import AiSummaryController from "./ai_summary_controller.js"
application.register("ai-summary", AiSummaryController)

// app/assets/src/application/js/stimulus/advanced_search_controller.js
import AdvancedSearchController from "./advanced_search_controller.js"
application.register("advanced-search", AdvancedSearchController)

// app/assets/src/application/js/stimulus/notes_controller.js
import NotesController from "./notes_controller.js"
application.register("notes", NotesController)

// app/assets/src/application/js/stimulus/expandable_controller.js
import ExpandableController from "./expandable_controller.js"
application.register("expandable", ExpandableController)

// app/assets/src/application/js/stimulus/expandable_list_controller.js
import ExpandableListController from "./expandable_list_controller.js"
application.register("expandable-list", ExpandableListController)

// app/assets/src/application/js/stimulus/fees_controller.js
import FeesController from "./fees_controller.js"
application.register("fees", FeesController)

// app/assets/src/application/js/stimulus/hold_requests_controller.js
import HoldRequestsController from "./hold_requests_controller.js"
application.register("hold-requests", HoldRequestsController)

// app/assets/src/application/js/stimulus/loan_controller.js
import LoanController from "./loan_controller.js"
application.register("loan", LoanController)

// app/assets/src/application/js/stimulus/loans_controller.js
import LoansController from "./loans_controller.js"
application.register("loans", LoansController)

// app/assets/src/application/js/stimulus/remote_loader_controller.js
import RemoteLoaderController from "./remote_loader_controller.js"
application.register("remote-loader", RemoteLoaderController)

// app/assets/src/application/js/stimulus/histogram_aggregation_controller.js
import HistogramAggregationController from "./histogram_aggregation_controller.js"
application.register("histogram-aggregation", HistogramAggregationController)

// app/components/watch_lists_panel_component/component_controller.js
import WatchListsPanelComponent__ComponentController from "../../../../../components/watch_lists_panel_component/component_controller.js"
application.register("watch-lists-panel-component--component", WatchListsPanelComponent__ComponentController)

// app/assets/src/application/js/stimulus/shelf_finder_controller.js
import ShelfFinderController from "./shelf_finder_controller.js"
application.register("shelf-finder", ShelfFinderController)

// app/assets/src/application/js/stimulus/modal_controller.js
import ModalController from "./modal_controller.js"
application.register("modal", ModalController)

// app/assets/src/application/js/stimulus/modal_dialog_controller.js
import ModalDialogController from "./modal_dialog_controller.js"
application.register("modal-dialog", ModalDialogController)

// app/assets/src/application/js/stimulus/barcode_controller.js
import BarcodeController from "./barcode_controller.js"
application.register("barcode", BarcodeController)

// app/assets/src/application/js/stimulus/qrcode_controller.js
import QRCodeController from "./qrcode_controller.js"
application.register("qrcode", QRCodeController)

// app/assets/src/application/js/stimulus/tooltip_controller.js
import TooltipController from "./tooltip_controller.js"
application.register("tooltip", TooltipController)

// app/assets/src/application/js/stimulus/color_mode_switcher_controller.js
import ColorModeSwitcherController from "./color_mode_switcher_controller.js"
application.register("color-mode-switcher", ColorModeSwitcherController)

// app/assets/src/application/js/stimulus/copy_to_clipboard.js
import CopyToClipboardComponent__Controller from "../../../../../components/copy_to_clipboard_component/controller.js"
application.register("copy-to-clipboard-component", CopyToClipboardComponent__Controller)

// app/assets/src/application/js/stimulus/bot_challenge_controller.js
import BotChallengeController from "./bot_challenge_controller.js"
application.register("bot-challenge", BotChallengeController)

// app/assets/src/application/js/stimulus/bot_challenge_stats_chart_controller.js
import BotChallengeStatsChartController from "./bot_challenge_stats_chart_controller.js"
application.register("bot-challenge-stats-chart", BotChallengeStatsChartController)

// app/assets/src/application/js/stimulus/ai_summary_feedback_controller.js
import AiSummaryFeedbackController from "./ai_summary_feedback_controller.js"
application.register("ai-summary-feedback", AiSummaryFeedbackController)

// app/assets/src/application/js/stimulus/ai_summary_stats_chart_controller.js
import AiSummaryStatsChartController from "./ai_summary_stats_chart_controller.js"
application.register("ai-summary-stats-chart", AiSummaryStatsChartController)
